import React from "react";
import ReactECharts from "echarts-for-react";

const HalfDoughnutChart = ({ title, data }) => {
  const option = {
    title: {
      text: title || "",
      left: "center",
      top: 10,
      textStyle: { fontSize: 16 },
    },
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
    },
    legend: {
      orient: "horizontal",
      top: 0,
    },
    series: [
      {
        type: "pie",
        radius: ["30%", "75%"], // inner & outer radius
        center: ["50%", "75%"], // push down to make semicircle
        startAngle: 0, // half chart
        endAngle: 180,
        // padAngle: 2,
        itemStyle: {
          shadowColor: "rgba(0, 0, 0, 0.4)",
          shadowBlur: 5,
          shadowOffsetX: 4,
          shadowOffsetY: 0,
          borderRadius: 10,
        },
        avoidLabelOverlap: false,
        clockwise: false,
        label: {
          show: true,
          position: "outside",
          formatter: "{b}\n{d}%",
        },
        data: data || [],
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      notMerge={true} // Merge options to avoid reinitialization
      style={{ width: "100%", height: "300px" }}
    />
  );
};

export default HalfDoughnutChart;
